import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const TermsPage = () => (
  <PublicLegalContentPage
    slug="terms"
    seoTitle="Terms of Service | Pleerity Enterprise Ltd"
    seoDescription="Terms of Service governing the use of services provided by Pleerity Enterprise Ltd."
    canonicalUrl="/legal/terms"
  />
);

export default TermsPage;
